import React from 'react';
import { FileSignature } from 'lucide-react';

export default function EmailSignatureBlock({ props, isSelected, onSelectSignature }) {
  if (props.signature_html) {
    return (
      <div style={{ padding: props.padding || '16px 24px' }}>
        <div dangerouslySetInnerHTML={{ __html: props.signature_html }} />
        {isSelected && (
          <button onClick={onSelectSignature} className="mt-2 text-xs text-stone-500 hover:text-stone-700 underline">Change signature</button>
        )}
      </div>
    );
  }

  return (
    <div style={{ padding: props.padding || '16px 24px' }}>
      <div className="border border-dashed border-stone-200 rounded-lg p-6 flex flex-col items-center gap-2">
        <FileSignature className="w-6 h-6 text-stone-300" />
        <p className="text-xs text-stone-400">Email signature</p>
        {isSelected && (
          <button onClick={onSelectSignature} className="px-3 py-1.5 text-xs font-medium bg-stone-900 text-white rounded-lg hover:bg-stone-800">
            Choose Signature
          </button>
        )}
      </div>
    </div>
  );
}
